import { createContext } from 'react';

import { DEFAULT_TOKENS, DesignTokens, UiScale } from '../../styles/designTokens';

export type DesignTokensContextValue = {
    /** The tokens currently in force (defaults ← tenant ← user preset ← draft). */
    tokens: DesignTokens;
    /** What Save should persist: defaults ← tenant ← draft, with the editing
     *  admin's personal scale left out. */
    savableTokens: DesignTokens;
    /** The tenant default as stored in app_config, before user/draft layers. */
    tenantTokens: Partial<DesignTokens> | null;
    /** Unsaved live-preview edits, held in sessionStorage. */
    draft: Partial<DesignTokens> | null;
    /** Whether audit mode (exaggerated tokens) is on. */
    auditMode: boolean;
    /** Merge a partial into the session draft — the live-preview path. */
    setDraft: (patch: Partial<DesignTokens> | null) => void;
    /** Persist the current tokens as the company default. */
    saveTenantDefault: (tokens: Partial<DesignTokens>) => Promise<void>;
    /** Persist null so the tenant follows future shipped defaults. */
    resetTenantDefault: () => Promise<void>;
    setAuditMode: (on: boolean) => void;
    scale: UiScale;
};

const Context = createContext<DesignTokensContextValue>({
    tokens: DEFAULT_TOKENS,
    savableTokens: DEFAULT_TOKENS,
    tenantTokens: null,
    draft: null,
    auditMode: false,
    setDraft: () => {},
    saveTenantDefault: async () => {},
    resetTenantDefault: async () => {},
    setAuditMode: () => {},
    scale: 'default'
});

export default Context;
export { Context };
